export default function() {
  return {
    // for saving the location data as per the layerIds
    geoData: {},
    // for saving the available layer ids for location data
    geoDataById: [],
    // for storing the search hoistories
    history: [],
    activeCity: null,
    activeLocation: [],
    zoom: 10,
    viewState: {},
  };
}
